export default {
  CASES_TABLE: {
    CASE_QUICK_FILTERS: {
      all: 'Všetky prípady',
      todo: 'Úlohy',
      todo_admin: 'Admin',
      todo_attorney: 'Advokát',
      notary_late: 'Notárske oneskorenie',
    },
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'Nastala chyba pri načítaní prípadov!',
      ERROR_WHILE_LOADING_PARTNERS: 'Nastala chyba pri načítaní partnerov!',
      ERROR_WHILE_LOADING_STATES: 'Nastala chyba pri načítaní stavov!',
      ERROR_WHILE_EXPORTING_CASES: 'Nastala chyba pri exporte prípadov!',
    },
    EXPORT: {
      BUTTON: 'Exportovať prípady (Excel)',
      FILENAME: 'export-pripadov',
    },
    FILTERS: {
      APPLY: 'Použiť',
      STAGE_LABEL: 'Hlavný stav',
      CASE_ID: {
        LABEL: 'ID prípadu',
        PLACEHOLDER: 'Začnite písať...'
      },
      DEBTOR_NAME: {
        LABEL: 'Dlžník',
        PLACEHOLDER: 'Začnite písať...'
      },
      CLIENT: {
        LABEL: 'Veriteľ',
        PLACEHOLDER: 'Začnite písať...',
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Začnite písať...',
      },
      PRODUCT: {
        LABEL: 'Produkt',
        PLACEHOLDER: 'Vyberte produkt...',
        NOTICE: 'Platobná výzva',
        DEMAND_LETTER: 'Advokátsky list',
        HARD_1: 'Platobný príkaz',
        HARD_2: 'Platobný príkaz - exekúcia',
        COFACE: 'Coface',
      },
      STAGE: {
        DRAFT: 'Návrh',
        ONGOING: 'Prebieha',
        CLOSED: 'Uzavreté',
      },
      STATE: {
        LABEL: 'Stav',
        PLACEHOLDER: 'Začnite písať...',
      },
      STARTED_AT: {
        LABEL: 'Dátum začiatku',
        MIN_LABEL: 'Dátum začiatku (od)',
        MAX_LABEL: 'Dátum začiatku (do)',
      },
      TRANSITION_AT: {
        LABEL: 'Dátum udalosť',
        MIN_LABEL: 'Dátum udalosť (od)',
        MAX_LABEL: 'Dátum udalosť (do)',
      },
      "CLEAR_ALL": "Vymazať filtre"
    },
    TABLE_INFO: {
      CLOSED: 'Uzavreté prípady',
      CLOSED_INFO:
        'Ide o prípady, ktoré boli buď úspešne uhradené, alebo uzavreté z iných dôvodov.',
      DRAFT: 'Koncepty',
      DRAFT_INFO:
        'Ide o prípady, ktoré ste prerušili. Ak ste sem prišli kliknutím na odkaz "Právnik a právne riešenia" z účtu Invoice.com na faktúre Számlázz.hu, každé takéto kliknutie vytvorilo koncept.',
      ONGOING: 'Prebiehajúce prípady',
      ONGOING_INFO:
        'Ide o prípady, ktoré boli úspešne spustené a momentálne prebiehajú. Ak budete mať s ktorýmkoľvek z nich úlohu na vybavenie, pošleme vám o tom e‑mailovú notifikáciu.',
    },
    HEADERS: {
      CASE_ID: 'ID prípadu',
      REMAINING_CLAIMS: 'Zostávajúce nároky',
      ORIGINAL_CLAIMS: 'Nárok',
      PAYMENT_STATUS: 'Stav úhrady',
      PARTIES: 'Strany',
      CLIENT: 'Veriteľ',
      STATE: 'Stav',
      STARTED_AT: 'Spustené',
      EXPECTED_TRANSITION: 'Očakávaný stav',
      LAST_EVENT: 'Posledná udalosť',
      DEADLINE: 'Lehota',
    },
    MORE_CURRENCIES: '+{{count}} ďalších',
    COUNTDOWN: '{{hours}} hodín {{minutes}} minút',
    COUNTDOWN_WITH_DAYS: '{{days}} dní {{hours}} hodín {{minutes}} minút',
    COUNTDOWN_UNTIL: 'Dokončenie najneskôr',
    COUNTDOWN_OVERDUE: 'Čoskoro sa skončí',
    CASE_ACTIONS: {
      DOWNLOAD_DOCUMENTS: 'Stiahnuť dokumenty',
      DELETE: 'Zmazať prípad',
      EDIT: 'Upraviť prípad',
      PAY_WITH_CARD: 'Zaplatiť kartou',
      RESEND_PROFORMA: 'Znova odoslať žiadosť o poplatok',
      RESEND_PROFORMA_CONFIRM: 'Poplatky sa zmenia. Po uložení chcete znova odoslať žiadosť o poplatok veriteľovi?',
      RESEND_PROFORMA_SUCCESS: 'Žiadosť o opätovné odoslanie proformy bola úspešne odoslaná.',
      RESEND_PROFORMA_ERROR: 'Proformu sa nepodarilo znova odoslať.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK: 'Vytvoriť úlohu na faktúru',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_CONFIRM: 'Notárske konaní poplatky sa znížia. Po uložení vytvoríme úlohu v Asane o vrátení platby.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_INCREASE_CONFIRM: 'Notárske konaní poplatky sa zvýšia. Po uložení odošleme veriteľovi žiadosť o poplatky.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_SUCCESS: 'Úloha v Asane bola úspešne vytvorená.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_ERROR: 'Úlohu v Asane sa nepodarilo vytvoriť.',
      BAILIFF_CONTACT: 'Kontakt exekútora',
      SEARCH_PLACEHOLDER: 'Hľadať...',
      NO_ACTIONS: 'Žiadne dostupné akcie',
    },
    START_PAYMENT_CHOICE: {
      TITLE: 'Úhrada poplatku za začatie prípadu',
      DESCRIPTION: 'Vyberte, prosím, akým spôsobom chcete uhradiť poplatok za začatie prípadu. O poplatku za začatie prípadu ',
      MORE_INFO: 'si môžete prečítať viac',
      CARD_TITLE: 'Platba kreditnou kartou',
      CARD_DESCRIPTION: 'Bezpečné a rýchle',
      TRANSFER_TITLE: 'Platba bankovým prevodom (proforma faktúra)',
      TRANSFER_DESCRIPTION: '48 hodín lehota',
      CREDIT_TITLE: 'Zaplatiť kreditmi',
      CREDIT_DESCRIPTION: 'Z predplateného zostatku',
      SUBMIT_CARD: 'Zaplatiť kartou',
      SUBMIT_TRANSFER: 'Požiadať o proforma faktúru',
      SUBMIT_CREDIT: 'Zaplatiť kreditmi',
      TOOLTIP: 'Úhrada poplatku za začatie prípadu',
    },
    TRANSFER_INSTRUCTIONS: {
      TITLE: 'Poslali sme vám proforma faktúru a údaje na prevod e-mailom.',
      DESCRIPTION: 'Váš prevod spracujeme do 24 hodín a začneme váš prípad.',
      AMOUNT_LABEL: 'Suma na prevod',
      BENEFICIARY_LABEL: 'Majiteľ účtu',
      ACCOUNT_NUMBER_LABEL: 'Číslo bankového účtu',
      REFERENCE_LABEL: 'Referencia',
      BUTTON_LABEL: 'Pokračovať',
    },
    ACTION_GROUPS: {
      CASE_ACTIONS: 'Operácie',
      NO_ITEMS: 'V tejto skupine nie sú žiadne položky',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Detaily',
      EVENTS_LABEL: 'Udalosti',
    },
    NO_CASES: {
      TITLE: 'Nenašiel sa žiadny prípad so zadanými kritériami',
    },
    ACCESSORY_CLAIM: 'súvisiaci nárok',
    PAYMENT_STATUS: {
      PARTIAL: 'Čiastočná úhrada',
      FULL: 'Úplná úhrada',
      PARTIAL_DISPUTE: 'Čiastočná námietka',
      FULL_DISPUTE: 'Úplná námietka',
      PARTIAL_AND_DISPUTE: 'Čiastočná úhrada, čiastočná námietka',
    },
    TOOLTIP: {
      ADDRESS_LABEL: 'Adresa',
      TAX_NUMBER_LABEL: 'Daňové číslo',
      EXPECTED_EVENT: 'Nasledujúci stav: {{event}}',
      DEADLINE: 'Lehota: {{date}}',
      DEADLINE_OVERDUE: 'Lehota: {{date}} uplynula',
      EXPECTED_TRANSITION_TIMING_UPCOMING: 'Vtedy: {{date}}',
      EXPECTED_TRANSITION_TIMING_OVERDUE: 'Čoskoro',
    },
    COPY_SUCCESS: "Identifikácia prípadu skopírovaná do schránky",
    DOWNLOAD_DOCUMENTS_DIALOG: {
      TITLE: 'Stiahnuť dokumenty prípadu',
      DESCRIPTION: 'Vyberte, ktoré dokumenty sa majú zahrnúť do zip súboru.',
      EVENT_ATTACHMENTS: 'Prílohy udalostí ({{count}})',
      LEGAL_RELATIONSHIP_CONTRACT: 'Zmluva o právnom vzťahu ({{count}})',
      CLAIM_FILES: 'Súbory nárokov ({{count}})',
      DOWNLOAD: 'Stiahnuť zip',
      CANCEL: 'Zrušiť',
      NO_DOCUMENTS: 'Tento prípad nemá žiadne dokumenty na stiahnutie.',
      LOAD_ERROR: 'Nepodarilo sa načítať dokumenty prípadu.',
      DOWNLOAD_ERROR: 'Nepodarilo sa stiahnuť dokumenty prípadu.',
    },
  },
};
